import { useSearchParams, Link } from 'react-router-dom';
import { type CSSProperties } from 'react';
import type { PortfolioData } from '../domain/portfolio.types';
import { ProjectDialog } from './ProjectDialog';

export function Projects({ data }: { data: PortfolioData }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedProjectIdx = searchParams.get('project');
  const featuredProjects = data.projects.filter(p => p.featured === true);
  const selectedProject = selectedProjectIdx !== null ? featuredProjects[Number(selectedProjectIdx)] || null : null;

  return (
    <>
      <section className="section" id="work">
        <div className="container">
          <div className="reveal" style={{ marginBottom: 56, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 20 }}>
            <div>
              <div className="section-tag">04 · Selected work</div>
              <h2 className="section-title">
                Things I've <span className="alt">shipped</span>.
              </h2>
              <p className="section-sub">A few backend-heavy and full-stack engagements from the last 24 months. Case studies on request.</p>
            </div>
            <Link className="btn" to="/projects" target="_blank" rel="noopener noreferrer">Full archive →</Link>
          </div>
          <div className="projects-grid">
            {featuredProjects.map((p, i) => (
              <div
                className={`project-card reveal size-${p.size}`}
                key={i}
                style={{ transitionDelay: `${(i % 3) * 60}ms`, cursor: 'pointer' }}
                onClick={(e) => { e.preventDefault(); setSearchParams({ project: String(i) }, { replace: false }); }}
              >
                <span className="slash"></span>
                <div className="project-cover">
                  {p.details?.images && p.details.images.length > 0 ? (
                    <img src={p.details.images[0]} alt={p.title} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0 }} />
                  ) : (
                    <div className="initials" style={{ '--initials-len': p.initials.length } as CSSProperties}>{p.initials}</div>
                  )}
                  {p.meta?.badge && p.meta.badge !== 'FEATURED' && <span className="badge">{p.meta.badge}</span>}
                  <span className="num">/ {String(i + 1).padStart(2, '0')}</span>
                  <span className="label">{p.meta?.label}</span>
                </div>
                <div className="project-meta">
                  <div className="project-tags">
                    {p.tags.map((t, j) => <span className="project-tag" key={j}>{t}</span>)}
                  </div>
                  <h3 className="project-title">
                    {p.title}
                    <span className="arrow">↗</span>
                  </h3>
                  <p className="project-blurb">{p.blurb}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ProjectDialog project={selectedProject} onClose={() => setSearchParams({}, { replace: false })} />
    </>
  );
}
